import { render, staticRenderFns } from "./ClubDetail.vue?vue&type=template&id=5cfdce9b&scoped=true"
import script from "./ClubDetail.vue?vue&type=script&lang=js"
export * from "./ClubDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfdce9b",
  null
  
)

export default component.exports